import TFlagDebugBanner from "./TFlagDebugBanner.vue";

export default TFlagDebugBanner;
